module.exports = __webpack_public_path__ + "static/media/logoWolf.a859dd17.gif";